"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.avatarStackNovoDark = exports.avatarStackNovo = exports.avatarStack = void 0;
const oxygen_theme_1 = __importDefault(require("@8x8/oxygen-theme"));
const { novo, novoDark } = oxygen_theme_1.default;
const avatarStackNovo = {
    backgroundHover: novo.ui05,
    borderColorHover: novo.ui01,
    borderColorFocus: novo.focus01,
    counterBackground: novo.ui07,
    counterColor: novo.textColor04,
};
exports.avatarStackNovo = avatarStackNovo;
const avatarStack = avatarStackNovo;
exports.avatarStack = avatarStack;
const avatarStackNovoDark = {
    backgroundHover: novoDark.ui05,
    borderColorHover: novoDark.ui01,
    borderColorFocus: novoDark.focus01,
    counterBackground: novoDark.ui07,
    counterColor: novoDark.textColor04,
};
exports.avatarStackNovoDark = avatarStackNovoDark;
